import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpenIcon, ScanLineIcon, CalendarIcon, RefreshCwIcon, CarrotIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpenIcon className="w-6 h-6 text-leaf" data-id="element-186" />,
    title: 'El Manual Maestro',
    desc: 'Estrategias psicológicas y prácticas para recuperar la autoridad en la mesa sin gritos ni negociaciones interminables.'
  }, {
    icon: <ScanLineIcon className="w-6 h-6 text-leaf" data-id="element-187" />,
    title: 'El Escáner de 3 Segundos',
    desc: "La técnica visual definitiva para detectar 'venenos' ocultos en las etiquetas del supermercado al instante."
  }, {
    icon: <CalendarIcon className="w-6 h-6 text-leaf" data-id="element-188" />,
    title: 'Menú Blindado de 7 Días',
    desc: 'Plan exacto de Desayuno, Almuerzo, Cena y 2 Meriendas detalladas paso a paso para empezar de inmediato.'
  }, {
    icon: <RefreshCwIcon className="w-6 h-6 text-leaf" data-id="element-189" />,
    title: 'Guía de Rotación (15 Días)',
    desc: 'El sistema para mantener la variedad en las comidas sin tener que pasar horas planificando o en la cocina.'
  }, {
    icon: <CarrotIcon className="w-6 h-6 text-leaf" data-id="element-190" />,
    title: 'Protocolo de Nutrición Infiltrada',
    desc: 'Técnicas probadas para camuflar vegetales y superalimentos en los platos favoritos que tus hijos ya aman.'
  }];
  return <section className="py-14 bg-white" data-id="element-191">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
        <FadeIn data-id="element-193">
          <div className="text-center mb-10" data-id="element-194">
            <h2 className="text-3xl md:text-4xl font-bold text-ink mb-6" data-id="element-195">
              Tu Arsenal Completo
            </h2>
            <p className="text-lg text-ink/70 max-w-2xl mx-auto" data-id="element-196">
              Todo lo que necesitas para transformar la alimentación de tu
              familia, estructurado para acción inmediata.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={`bg-cream p-8 rounded-2xl border border-forest/10 hover:border-leaf/30 transition-colors ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-198">
              <div className="bg-white w-12 h-12 rounded-xl flex items-center justify-center shadow-sm mb-6 mx-auto" data-id="element-199">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-ink mb-3 text-center" data-id="element-200">
                {item.title}
              </h3>
              <p className="text-ink/70 text-sm leading-relaxed text-center" data-id="element-201">
                {item.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}